import { CONDOMINIUM_TYPES, AUTH_TYPES } from "./types";
import { Toast } from "./../components/UI/toast/Toast";
import { findOneConfig, updateConfig } from "../helpers/api/condominium";
import { findAllCurrencies } from "../helpers/api/currency";
import { fetchAllPages } from "../helpers/api/pagination";

export const SelectCondominium =
  (condominiumId, name, address, id) => async (dispatch) => {
    dispatch(SC(condominiumId));
    dispatch(SCN(name));
    dispatch(SCA(address));
    dispatch(SCI(id));
    try {
      const { data } = await findOneConfig(condominiumId);
      let currencyId = data.currency_id;

      // Si el condominio aún no tiene una moneda configurada, pero solo tiene una
      // moneda disponible (caso frecuente: un único "Bolivar" registrado), se
      // asigna y se guarda automáticamente en vez de obligar a elegirla a mano.
      if (!currencyId) {
        try {
          const { data: currencies } = await fetchAllPages((page, pageSize) => findAllCurrencies(page, pageSize, {
            condominium_id: condominiumId,
          }));
          if (currencies?.length === 1) {
            currencyId = currencies[0].id;
            await updateConfig(condominiumId, {
              automatic: 0,
              currency_id: currencyId,
            });
          }
        } catch (innerError) {
          // El selector de moneda sigue disponible manualmente si esto falla
        }
      }

      dispatch({ type: AUTH_TYPES.SET_CURRENCY, payload: currencyId });
    } catch (error) {
      // El selector de moneda sigue disponible manualmente si esto falla
    }
    Toast.fire({
      type: "info",
      title: "Has seleccionado un condominio.",
    });
  };

export const UnselectCondominium = () => async (dispatch) => {
  dispatch(USC());
  Toast.fire({
    type: "info",
    title: "Has deseleccionado un condominio.",
  });
};

export const SelectProvider = (provider) => async (dispatch) => {
  dispatch(SP(provider));
};

export const UnselectProvider = () => async (dispatch) => {
  dispatch(USP());
};

export const MakingRequest = () => async (dispatch) => {
  dispatch(MR());
};

export const NotMakingRequest = () => async (dispatch) => {
  dispatch(NMR());
};

export const SC = (payload) => {
  return { type: CONDOMINIUM_TYPES.SELECT_CONDOMINIUM, payload };
};
export const SCN = (payload) => ({
  type: CONDOMINIUM_TYPES.CONDOMINIUM_NAME,
  payload,
});
export const SCA = (payload) => ({
  type: CONDOMINIUM_TYPES.CONDOMINIUM_ADDRESS,
  payload,
});
export const SCI = (payload) => ({
  type: CONDOMINIUM_TYPES.CONDOMINIUM_ID,
  payload,
});
export const USC = () => ({ type: CONDOMINIUM_TYPES.UNSELECT_CONDOMINIUM });
export const SP = (payload) => ({
  type: CONDOMINIUM_TYPES.SELECT_PROVIDER,
  payload,
});
export const USP = () => ({ type: CONDOMINIUM_TYPES.UNSELECT_PROVIDER });
export const MR = () => ({ type: CONDOMINIUM_TYPES.MAKING_REQUEST });
export const NMR = () => ({ type: CONDOMINIUM_TYPES.NOT_MAKING_REQUEST });
